import { getMeta } from '@helpcenter/meta';
// eslint-disable-next-line no-restricted-imports
import { HelpHelpCenterAri, HelpPageAri } from '@atlassian/ari';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router';
import HubHomeContentWrapperQuery from '@atlassian/hub-home/HubHomeContentWrapperQueryParameters';
import type { hubHomeContentWrapperQuery } from '@atlassian/hub-home/HubHomeContentWrapperQueryParameters';

export const EditLayoutResource = createRelayResource<hubHomeContentWrapperQuery>({
    type: 'EDIT_HUB_LAYOUT',
    getQuery: ({ match }, { cloudId }) => {
        const activationId = getMeta('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        const pageId = match.params.pageId || '';
        const computedHelpCenterAri = HelpHelpCenterAri.create({ activationId, helpCenterId }).toString();
        const computedPageAri = HelpPageAri.create({ activationId, pageId: pageId || helpCenterId }).toString();
        return {
            parameters: HubHomeContentWrapperQuery,
            variables: {
                cloudId,
                hubAri: computedHelpCenterAri,
                hubEditMode: true,
                pageAri: computedPageAri,
            },
            options: {
                fetchPolicy: 'store-or-network',
            },
        };
    },
});
